export const currency = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});
export const percent = new Intl.NumberFormat('es-CO', {
    style: 'percent',
    maximumFractionDigits: 2
});
